export default "__VITE_ASSET__da8bee4e__"